<script>
export default {
    name: "ReturnToPharmacy",

    data() {

        return {
            returnDrug: {
                qty: 0,
                memo: ``,
            },
        };
    },

    props: {
        showModal: {
            type: Boolean,
            default: false,
        },

        patient: {
            type: Object,
            required: true,
            default: () => ({}),
        },

        prescription: {
            type: Object,
            required: true,
            default: () => ({}),
        },
    },

    methods: {

        saveReturnToPharmacy() {
            if(!window.confirm(`Confirm Return To Pharmacy`)) return;

            if(parseFloat(this.returnDrug.qty) > 0 && 
                (parseFloat(this.returnDrug.qty) > parseFloat(this.prescription.notAdministeredQty))) {
                window.Swal.fire({ type: `error`, text: `Qty to return is invalid.`});

                return;
            }

            const returnToPharmacy = {
                encounterID: 0,
                patientID: this.patient.patienT_ID,
                patientName: this.patient.names,
                visitNo: this.patient.visitNo,
                returnTime: this.$moment().format(`HH:MM`),
                userName: this.$root.username,
                memo: this.returnDrug.memo,
                cancelled: false,
                returnDetails: [
                    {
                        qty: this.returnDrug.qty,
                        itemId: this.prescription.itemId,
                        itemName: this.prescription.drug,
                        prescriptionId: this.prescription.code,
                    },
                ],

            };

            this.$root.loading = true;
            this.$http.post(`MedicalFile/ReturnPatientDrug`, returnToPharmacy).then(({ data }) => {
                this.$emit(`refresh`);
                this.$root.loading = false;
                this.$emit(`closeModal`);
                window.Swal.fire({ type: `success`, text: data, });
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-1/2 w-full">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Stop Administration</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center">
        <div class="w-full flex flex-wrap bg-gray-300 p-2">
            <div class="flex-1 p-1">Name: {{ patient.names }}</div>
            <div class="flex-1 p-1">MRN: {{ patient.patienT_ID }}</div>
            <div class="flex-1 p-1">Drug: {{ prescription.drug }}</div>
        </div>
        <div class="w-full flex flex-wrap p-1 mt-1">
            <div class="md:w-1/2 w-full p-1">
                <label for="grid-remaining" class="label-control">Remaining:</label>
                <input type="number" id="grid-remaining" disabled 
                    class="input-control input-sm text-xs bg-gray-200" 
                    :value="prescription.notAdministeredQty">
            </div>
            <div class="md:w-1/2 w-full p-1">
                <label for="grid-qty-returned" class="label-control">Qty to Return:</label>
                <input type="number" 
                    min="0"
                    v-model.number="returnDrug.qty"
                    id="grid-qty-returned" 
                    class="input-control input-sm text-xs text-right">
            </div>
            <div class="w-full p-1">
                <label for="return-comment" class="label-control">Comment</label>
                <textarea v-model.trim="returnDrug.memo" rows="3" 
                   id="return-comment" class="input-control input-sm text-xs"></textarea>
            </div>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button class="btn-danger btn-sm text-xs rounded mr-6" 
        @click.prevent="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
    <button 
        @click.prevent="saveReturnToPharmacy"
        class="btn-primary btn-sm text-xs rounded">
            <i class="fa fa-save"></i> Save</button>
  </template>
</tail-modal>
</template>
